import React from 'react';
import { SEMANTIC_COLORS } from '@/constant/unit/color';
import { S } from './style';
import { CaretRight } from '../../atom/Icon';
export default function FootNotes({ content, customStyle }) {
    return (<S.Layout customStyle={customStyle}>
      <CaretRight color={SEMANTIC_COLORS.PRIMARY_ICON} size='20px'/>
      <div>{content}</div>
    </S.Layout>);
}
